import { Component, OnInit } from "@angular/core";
import { TabelaBoletaService } from "../../services/tabela-boleta.service";
import { FileService } from "../../services/file.service";
import { SnackbarService } from "../../services/snackbar.service";
import { LoaderService } from "../../services/loader.service";
import { DownloadService } from "../../services/download.service";
import { faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";
import { DomainService, TicketType } from "../../services/domain.service";
import { data } from "jquery";

@Component({
  selector: "tabela-historico-boleta",
  templateUrl: "./tabela-historico-boleta.component.html",
  styleUrls: ["./tabela-historico-boleta.component.scss"],
})
export class TabelaHistoricoBoletaComponent implements OnInit {
  constructor(
    private snackBarService: SnackbarService,
    private loaderService: LoaderService,
    private fileService: FileService,
    private downloadService: DownloadService,
    private tabelaBoletaService: TabelaBoletaService,
    private domainService: DomainService
  ) {}

  displayedColumns = ["fileName", "userName", "createDate", "ticketType"];

  Hoje: Date = new Date();
  starDate: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  endDate: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  Arquivo = "";
  StatusFilter: number;
  Statuses: Array<any> = null;
  FundFilter: number;
  Funds: Array<any> = null;
  expandedElement: any;

  dataSource = null;

  defaultPage = 1;
  currentPage = 1;
  defaultSize = 10;
  totalPages: number = null;
  totalItems: number = null;
  listedPages = [];
  firstItemOnPage: number;
  lastItemOnPage: number;

  faDownload = faDownload;
  ticketTypeFilter: number;
  TicketTypes: TicketType[];
  tickets = {
    1: "FundQuota",
    2: "PrivateFixedIncome",
    3: "PublicFixedIncome",
    4: "Contracted",
    5: "Futures",
    6: "SwapCetip",
    7: "Margin",
    8: "CurrencyTerm",
    10: "Transfer",
    11: "Loan",
    12: "Exchange",
    13: "Expenses",
    14: "VariableIncome",
    15: "Liabilities",
  };

  ngOnInit(): void {
    this.getReceivables();
    this.domainService.ListTicketTypes().subscribe((types) => {
      types.sort(function (a: any, b: any) {
        return a.name > b.name ? 1 : -1;
      });
      this.TicketTypes = types;
    });
  }

  periodoError() {
    if (this.endDate == null || this.starDate == null) {
      return true;
    }
    const dateDiff =
      (this.endDate.getTime() - this.starDate.getTime()) / 86400000;
    return dateDiff > 30 || dateDiff < 0;
  }

  download(name: string) {
    const download = this.fileService.download(name);

    return download.subscribe(
      (data: Blob) => {
        this.downloadService.downloadFile(data, name);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível fazer o download do arquivo.",
          "OK"
        );
      }
    );
  }

  getReceivables(
    page: number = this.defaultPage,
    pageSize: number = this.defaultSize
  ) {
    const params: any[] = [
      page,
      pageSize,
      this.ticketTypeFilter,
      this.starDate,
      this.endDate,
    ];

    this.tabelaBoletaService.GetFiles(...params).subscribe((s) => {
      const rows = [];
      s.results.forEach((element) => {
        element.ticketType = this.tickets[element.ticketType];
        rows.push(element);
      });
      this.dataSource = rows;
      this.totalPages = s.pageCount;
      this.totalItems = s.rowCount;
      this.firstItemOnPage = s.firstRowOnPage;
      this.lastItemOnPage = s.lastRowOnPage;
      this.currentPage = s.currentPage;
      this.listedPages = [];

      let startPage = this.currentPage - 2;
      if (startPage <= 0) {
        startPage = 1;
      }

      let maxPage = this.currentPage + 2;
      while (maxPage > this.totalPages) {
        maxPage--;
      }

      for (let i = startPage; i <= maxPage; i++) {
        this.listedPages.push(i);
      }
    });
  }
}
